import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/regenerator";
import "core-js/modules/es.promise.finally.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { InvalidOperationError, ObjectDisposedError } from "./Error";
import { List } from "./List";
import { Deferred } from "./Promise";
var SubscriberType;

(function (SubscriberType) {
  SubscriberType[SubscriberType["Dequeue"] = 0] = "Dequeue";
  SubscriberType[SubscriberType["Peek"] = 1] = "Peek";
})(SubscriberType || (SubscriberType = {}));

export var Queue = /*#__PURE__*/function () {
  function Queue(list) {
    var _this = this;

    _classCallCheck(this, Queue);

    this.privPromiseStore = new List();
    this.privIsDrainInProgress = false;
    this.privIsDisposing = false;
    this.privDisposeReason = null;

    this.enqueue = function (item) {
      _this.throwIfDispose();

      _this.enqueueFromPromise(new Promise(function (resolve, reject) {
        resolve(item);
      }));
    };

    this.enqueueFromPromise = function (promise) {
      _this.throwIfDispose();

      promise.then(function (val) {
        _this.privList.add(val);
        /* tslint:disable:no-empty */

      }, function (error) {});
    };

    this.dequeue = function () {
      _this.throwIfDispose();

      var deferredSubscriber = new Deferred();

      if (_this.privSubscribers) {
        _this.privSubscribers.add({
          deferral: deferredSubscriber,
          type: SubscriberType.Dequeue
        });

        _this.drain();
      }

      return deferredSubscriber.promise;
    };

    this.peek = function () {
      _this.throwIfDispose();

      var deferredSubscriber = new Deferred();
      var subs = _this.privSubscribers;

      if (subs) {
        _this.privSubscribers.add({
          deferral: deferredSubscriber,
          type: SubscriberType.Peek
        });

        _this.drain();
      }

      return deferredSubscriber.promise;
    };

    this.length = function () {
      _this.throwIfDispose();

      return _this.privList.length();
    };

    this.isDisposed = function () {
      return _this.privSubscribers == null;
    };

    this.drain = function () {
      if (!_this.privIsDrainInProgress && !_this.privIsDisposing) {
        _this.privIsDrainInProgress = true;
        var subs = _this.privSubscribers;
        var lists = _this.privList;

        if (subs && lists) {
          while (lists.length() > 0 && subs.length() > 0 && !_this.privIsDisposing) {
            var subscriber = subs.removeFirst();

            if (subscriber.type === SubscriberType.Peek) {
              subscriber.deferral.resolve(lists.first());
            } else {
              var dequeuedItem = lists.removeFirst();
              subscriber.deferral.resolve(dequeuedItem);
            }
          } // note: this block assumes cooperative multitasking, i.e.,
          // between the if-statement and the assignment there are no
          // thread switches.
          // Reason is that between the initial const = this.; and this
          // point there is the derral.resolve() operation that might have
          // caused recursive calls to the Queue, especially, calling
          // Dispose() on the queue alredy (which would reset the var
          // here to null!).
          // That should generally hold true for javascript...


          if (_this.privSubscribers === subs) {
            _this.privSubscribers = subs;
          } // note: this block assumes cooperative multitasking, i.e.,
          // between the if-statement and the assignment there are no
          // thread switches.
          // Reason is that between the initial const = this.; and this
          // point there is the derral.resolve() operation that might have
          // caused recursive calls to the Queue, especially, calling
          // Dispose() on the queue alredy (which would reset the var
          // here to null!).
          // That should generally hold true for javascript...


          if (_this.privList === lists) {
            _this.privList = lists;
          }
        }

        _this.privIsDrainInProgress = false;
      }
    };

    this.throwIfDispose = function () {
      if (_this.isDisposed()) {
        if (_this.privDisposeReason) {
          throw new InvalidOperationError(_this.privDisposeReason);
        }

        throw new ObjectDisposedError("Queue");
      } else if (_this.privIsDisposing) {
        throw new InvalidOperationError("Queue disposing");
      }
    };

    this.privList = list ? list : new List();
    this.privDetachables = [];
    this.privSubscribers = new List();
    this.privDetachables.push(this.privList.onAdded(this.drain));
  }

  _createClass(Queue, [{
    key: "drainAndDispose",
    value: function drainAndDispose(pendingItemProcessor, reason) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var subs, subscriber, _iterator, _step, detachable, promiseArray;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.isDisposed() && !this.privIsDisposing)) {
                  _context.next = 30;
                  break;
                }

                this.privDisposeReason = reason;
                this.privIsDisposing = true;
                subs = this.privSubscribers;

                if (subs) {
                  while (subs.length() > 0) {
                    subscriber = subs.removeFirst(); // TODO: this needs work (Resolve(null) instead?).

                    subscriber.deferral.resolve(undefined); // subscriber.deferral.reject("Disposed");
                  } // note: this block assumes cooperative multitasking, i.e.,
                  // between the if-statement and the assignment there are no
                  // thread switches.
                  // Reason is that between the initial const = this.; and this
                  // point there is the derral.resolve() operation that might have
                  // caused recursive calls to the Queue, especially, calling
                  // Dispose() on the queue alredy (which would reset the var
                  // here to null!).
                  // That should generally hold true for javascript...


                  if (this.privSubscribers === subs) {
                    this.privSubscribers = subs;
                  }
                }

                _iterator = _createForOfIteratorHelper(this.privDetachables);
                _context.prev = 6;

                _iterator.s();

              case 8:
                if ((_step = _iterator.n()).done) {
                  _context.next = 14;
                  break;
                }

                detachable = _step.value;
                _context.next = 12;
                return detachable.detach();

              case 12:
                _context.next = 8;
                break;

              case 14:
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](6);

                _iterator.e(_context.t0);

              case 19:
                _context.prev = 19;

                _iterator.f();

                return _context.finish(19);

              case 22:
                if (!(this.privPromiseStore.length() > 0 && pendingItemProcessor)) {
                  _context.next = 28;
                  break;
                }

                promiseArray = [];
                this.privPromiseStore.toArray().forEach(function (wrapper) {
                  promiseArray.push(wrapper);
                });
                return _context.abrupt("return", Promise.all(promiseArray).finally(function () {
                  _this2.privSubscribers = null;

                  _this2.privList.forEach(function (item, index) {
                    pendingItemProcessor(item);
                  });

                  _this2.privList = null;
                  return;
                }).then());

              case 28:
                this.privSubscribers = null;
                this.privList = null;

              case 30:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 16, 19, 22]]);
      }));
    }
  }, {
    key: "dispose",
    value: function dispose(reason) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.drainAndDispose(null, reason);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return Queue;
}();